<script>

    import { pickupStore } from '../stores'

    import DateMethod from '../$methods/date.method'
    import DetailsCard from '../$components/details.card.svelte'
    import DetailsFields from '../$components/details.fields.svelte'
    import DetailsField from '../$components/details.field.svelte'
    import ButtonModal from '../$components/button.modal.svelte'

</script>

<DetailsCard
    title={$pickupStore.guide || 'Recogida'}
    meta={$pickupStore.folio ? `Folio ${$pickupStore.folio}` : ''}
    statusValue={$pickupStore.status}
>
    <DetailsFields>
        <DetailsField label="Creación" value={DateMethod.dateTimeLarge($pickupStore.created)} />
        <DetailsField label="Usuario">
            <div>
                <div>{ $pickupStore.user.name }</div>
                <div>{ $pickupStore.user.email }</div>
            </div>
        </DetailsField>
        <DetailsField label="Proveedor" value={$pickupStore.provider} />
        <DetailsField label="Paquetes" value={ String($pickupStore.packageTotal) } />
        <DetailsField label="Medidas" value={`${$pickupStore.package.width} cm × ${$pickupStore.package.height} cm × ${$pickupStore.package.length} cm · ${$pickupStore.package.weight} kg`} />
        <DetailsField label="Contenido" value={`${$pickupStore.package.content} · $${$pickupStore.package.value}`} />
    </DetailsFields>

    <div class="address-block is-light mt-4">
        <div class="is-size-7 has-text-weight-semibold mb-3">Dirección</div>
        <DetailsFields>
            <DetailsField label="Contacto" value={$pickupStore.location.contact} />
            <DetailsField label="RFC" value={$pickupStore.location.rfc} />
            <DetailsField label="Corporación" value={$pickupStore.location.corporate} />
            <DetailsField label="Teléfono" value={$pickupStore.location.phone} />
            <DetailsField label="Correo" value={$pickupStore.location.email} mono />
            <DetailsField label="Código postal" value={$pickupStore.location.zipcode} />
            <DetailsField label="Estado" value={$pickupStore.location.state} />
            <DetailsField label="Ciudad" value={$pickupStore.location.city} />
            <DetailsField label="Municipio" value={$pickupStore.location.municipality} />
            <DetailsField label="Colonia" value={$pickupStore.location.colony} />
            <DetailsField label="Calle" value={$pickupStore.location.street} />
            <DetailsField label="Exterior" value={$pickupStore.location.number} />
            <DetailsField label="Interior" value={$pickupStore.location.apartment} />
            <DetailsField label="Referencias" value={$pickupStore.location.references} />
        </DetailsFields>
    </div>

    <div slot="footer">
        <div class="is-flex is-justify-content-flex-end is-align-items-center">
            <ButtonModal modalId="pickup_update_modal" icon="edit" text="Actualizar" />
        </div>
    </div>
</DetailsCard>
